<template>
  <div class="hotel-container">
    <div class="float-left">
      <!-- <div class="img-item show-img" v-if="data.baseImg" :style="{'background-image': `url(${data.baseImg})`}"> </div> -->
      <div class="img-item show-img-1" v-if="!data.baseImg"/>
      <div class="img-item show-img" :style="{'background-image': `url(${data.baseImg})`}" v-if="data.baseImg"/>
    </div>

    <div class="hotel-data">
      <div class="flex flex-wrap gap-4">
        <div class="label label-grey-200 text-primary" v-if="catNm">{{catNm}}</div>
        <div class="menu-id" v-if="data.menu_id">[メニューNo.{{data.menu_id}}]</div>
        <div class="menu-id">{{data.menu_content}}</div>
      </div>
      <div :class="data.type">
        <h4 class="title1" v-if="data.title1"><span v-html="data.title1.replaceAll('\n', '<br>')"> </span></h4>
        <h3 class="title2" v-if="data.title2"><span v-html="data.title2.replaceAll('\n', '<br>')"> </span></h3>
      </div>
      <div :class="data.type">
        <h3 class="two-lines-ellipsis">{{data.title3}}</h3>
        <div class="py-2">
          <div class="meta-item" v-if="data.phone">
            <i class="icon icon-bor-phone-call icon-sm pr-3" />
            <span>{{data.phone}}</span>
          </div>
        </div>
        <div v-if="checkPointGrntNumAmt()">
          <span>付与ベネポ：{{data.pointGrntNumAmt}} ポイント</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'item-order',
  components: {},
  props: ['data'],
  data() {
    return {
      dataItemOrder: '',
      catNm: '',
      catLrgClassNm: '',
      catMidClassNm: '',
      catSmlClassNm: ''
    }
  },
  beforeMount() {
    this.dataItemOrder = this.data
  },
  
  mounted() {
    this.getCatNm()
    
  },
  watch: {
    data() {
      this.getCatNm()
    }
  },
  methods: {
    getImg(data) {
      if (data.baseImg) {
        return data.baseImg
      } 
      return require('@/assets/images/slide-img-placeholder.png')
    },
    checkPointGrntNumAmt() {
      if(this.dataItemOrder.pointGrntNumAmt) {
        return true
      }
      return false
    },
    getCatNm() {
      this.dataItemOrder = _.cloneDeep(this.data)
      this.catLrgClassNm = _.get(this.dataItemOrder, 'label.catLrgClassNm', null)
      this.catMidClassNm = _.get(this.dataItemOrder, 'label.catMidClassNm', null)
      this.catSmlClassNm = _.get(this.dataItemOrder, 'label.catSmlClassNm', null)

      if(!this.catLrgClassNm && !this.catMidClassNm && this.catSmlClassNm) {
        this.catNm = `${this.catSmlClassNm}`
      }
      if(!this.catLrgClassNm && this.catMidClassNm && !this.catSmlClassNm) {
        this.catNm = `${ this.catMidClassNm}`
      }
      if(this.catLrgClassNm && !this.catMidClassNm && this.catSmlClassNm) {
        this.catNm = `${ this.catLrgClassNm}`
      }
      if(!this.catLrgClassNm && this.catMidClassNm  && this.catSmlClassNm) {
        this.catNm = `${this.catMidClassNm  }・${ this.catSmlClassNm}`
      }
      if(this.catLrgClassNm && !this.catMidClassNm && this.catSmlClassNm) {
        this.catNm = `${this.catLrgClassNm  }・${ this.catSmlClassNm}`
      }
      if(this.catLrgClassNm && this.catMidClassNm && !this.catSmlClassNm) {
        this.catNm = `${this.catLrgClassNm  }・${ this.catMidClassNm}`
      }
      if(this.catLrgClassNm && this.catMidClassNm && this.catSmlClassNm) {
        this.catNm = `${this.catLrgClassNm  }・${  this.catMidClassNm  }・${ this.catSmlClassNm}`
      }
      if(this.catLrgClassNm && !this.catMidClassNm && !this.catSmlClassNm) {
        this.catNm = `${ this.catLrgClassNm}`
      }
    }
  }
}
</script>

<style lang="scss">
  @import './style.scss';
</style>
